import React, { useState } from 'react';
import { Row, Col, Card, Form, Input, Button, Typography, message } from 'antd';
import { 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined,
  GlobalOutlined,
  LinkedinOutlined,
  GithubOutlined,
  SendOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

const Contact = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      setLoading(false);
      message.success('Thank you! Your message has been sent successfully. I\'ll get back to you soon.');
      form.resetFields();
    }, 2000);
  };

  const contactInfo = [
    {
      icon: <EnvironmentOutlined />,
      title: 'Location',
      content: 'New York, NY'
    },
    {
      icon: <PhoneOutlined />,
      title: 'Phone',
      content: '+1 347 399 8354',
      link: 'tel:+13473998354'
    },
    {
      icon: <MailOutlined />,
      title: 'Email',
      content: 'katendaenock@gmail.com',
      link: 'mailto:katendaenock@gmail.com'
    },
    {
      icon: <GlobalOutlined />,
      title: 'Website',
      content: 'katendaenock.com',
      link: 'https://katendaenock.com'
    }
  ];

  return (
    <section id="contact" className="section section-light">
      <div className="container">
        <div className="section-header">
          <Title level={2} className="section-title">Get In Touch</Title>
          <Paragraph className="section-subtitle">Let's discuss your next project</Paragraph>
        </div>

        <Row gutter={[48, 48]}>
          <Col xs={24} lg={12}>
            <div className="fade-in-up">
              <Card style={{ height: '100%' }}>
                <Title level={3} style={{ marginBottom: '16px', color: '#1890ff' }}>
                  Let's Work Together
                </Title>
                
                <Paragraph style={{ fontSize: '1.1rem', marginBottom: '32px' }}>
                  I'm always interested in new opportunities and exciting projects. 
                  Whether you need a full-stack application, financial system, or 
                  graphics design work, I'd love to hear from you.
                </Paragraph>
                
                <div style={{ marginBottom: '32px' }}>
                  {contactInfo.map((info, index) => (
                    <Card
                      key={index}
                      size="small"
                      style={{ 
                        marginBottom: '16px',
                        border: '1px solid #f0f0f0'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div style={{
                          width: '50px',
                          height: '50px',
                          background: '#1890ff',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: '18px',
                          flexShrink: 0
                        }}>
                          {info.icon}
                        </div>
                        <div>
                          <Title level={5} style={{ margin: 0, marginBottom: '4px' }}>
                            {info.title}
                          </Title>
                          {info.link ? (
                            <a 
                              href={info.link} 
                              style={{ 
                                color: '#1890ff', 
                                textDecoration: 'none',
                                fontWeight: 500
                              }}
                            >
                              {info.content}
                            </a>
                          ) : (
                            <Text>{info.content}</Text>
                          )}
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>

                <div>
                  <Title level={4} style={{ marginBottom: '16px' }}>Connect With Me</Title>
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <Button
                      type="text"
                      icon={<LinkedinOutlined style={{ color: '#1890ff', fontSize: '20px' }} />}
                      href="https://linkedin.com/in/katenda-enock-349657143"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ 
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        border: '2px solid #f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white'
                      }}
                    />
                    <Button
                      type="text"
                      icon={<GithubOutlined style={{ color: '#1890ff', fontSize: '20px' }} />}
                      href="https://github.com/katenda"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ 
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        border: '2px solid #f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white'
                      }}
                    />
                    <Button
                      type="text"
                      icon={<MailOutlined style={{ color: '#1890ff', fontSize: '20px' }} />}
                      href="mailto:katendaenock@gmail.com"
                      style={{ 
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        border: '2px solid #f0f0f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white'
                      }}
                    />
                  </div>
                </div>
              </Card>
            </div>
          </Col>

          <Col xs={24} lg={12}>
            <div className="fade-in-up" style={{ animationDelay: '0.2s' }}>
              <Card>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  size="large"
                >
                  <Form.Item
                    label="Full Name"
                    name="name"
                    rules={[{ required: true, message: 'Please enter your name' }]}
                  >
                    <Input placeholder="Your full name" />
                  </Form.Item>
                  
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      { required: true, message: 'Please enter your email' },
                      { type: 'email', message: 'Please enter a valid email' }
                    ]}
                  >
                    <Input placeholder="your.email@example.com" />
                  </Form.Item>
                  
                  <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[{ required: true, message: 'Please enter a subject' }]}
                  >
                    <Input placeholder="What's this about?" />
                  </Form.Item>
                  
                  <Form.Item
                    label="Message"
                    name="message"
                    rules={[{ required: true, message: 'Please enter your message' }]}
                  >
                    <TextArea 
                      rows={6} 
                      placeholder="Tell me about your project or opportunity..."
                    />
                  </Form.Item>
                  
                  <Form.Item>
                    <Button 
                      type="primary" 
                      htmlType="submit"
                      loading={loading}
                      icon={<SendOutlined />}
                      size="large"
                      block
                      style={{ height: '48px' }}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Contact;